// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6e3d0335","455":"f8b556df","830":"b7469a57","977":"c47836ed"}[chunkId] + ".chunk.js";
};